module.exports = __webpack_public_path__ + "img/lacava_loader.0922e38c.svg";